export const checksums = {
  "articles": "v3.5.0--gP--TQ1cA6SXz7RXpavDDc7Mn2ddUsjeNvoM-_LZUy0",
  "persons": "v3.5.0--tjw0K7FV12IC8EADPeHTUOMRxPvDdV8ArQADSW0TL4Y",
  "projects": "v3.5.0--46k6f-210o0xcw0o8RrRphKu8vMksWQ7AAm_AnlQV2E",
  "theses": "v3.5.0--9__lZb1d1SGeOf8DXmlLD4QZ8DJ8tPrgvC_E5J2q_jw"
}
export const checksumsStructure = {
  "articles": "ayLiroFYui3tfAozfVWWepfnbgEHKtcrrv_shxx80fE",
  "persons": "u-oj00Q_E0CJaRHEcfhz5M-y8RjcfUA-xSMU7OB8x68",
  "projects": "xgjlOQGYMGfxu5K6TatRLWib-pqzQHNjauGxq8h0bIU",
  "theses": "G523UHt6uQ445TVEF7ThRi4ryVKmlWlVzKsxYv_cfcE"
}

export const tables = {
  "articles": "_content_articles",
  "persons": "_content_persons",
  "projects": "_content_projects",
  "theses": "_content_theses",
  "info": "_content_info"
}

export default {
  "articles": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authors": "json",
      "body": "json",
      "date": "string",
      "description": "string",
      "extension": "string",
      "image": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "related_works": "json",
      "seo": "json",
      "sitemap": "json",
      "stem": "string",
      "subtitle": "string"
    }
  },
  "persons": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "address": "json",
      "body": "json",
      "category": "string",
      "description": "string",
      "ecampusPersonId": "string",
      "email": "string",
      "en": "json",
      "extension": "string",
      "external": "boolean",
      "externalProfiles": "json",
      "fax": "string",
      "meta": "json",
      "name": "json",
      "navigation": "json",
      "path": "string",
      "personId": "string",
      "phone": "string",
      "picture": "json",
      "projects": "json",
      "publications": "json",
      "room": "string",
      "seo": "json",
      "sitemap": "json",
      "stem": "string",
      "website": "string"
    }
  },
  "projects": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "metadata": "json",
      "navigation": "json",
      "path": "string",
      "projectId": "string",
      "projectStatus": "string",
      "seo": "json",
      "stem": "string",
      "url": "json"
    }
  },
  "theses": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "languageSpecific": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "relevance": "json",
      "seo": "json",
      "status": "string",
      "stem": "string",
      "studentName": "string",
      "supervisor": "string",
      "tutor": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}